import { parseCoordinates, straightLineDistance, type Coordinates } from './flight-geometry.js';

export function CoordinateField({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const point = parseCoordinates(value);
  const query = point ? `${point.latitude},${point.longitude}` : '';
  return (
    <div className="coordinateField">
      <label>
        <span>
          Coordenadas de {label}{' '}
          <span aria-hidden="true" style={{ color: '#b42318' }}>
            *
          </span>
        </span>
        <input
          required
          value={value}
          placeholder="-22.97, -44.444444"
          onChange={(e) => onChange(e.target.value)}
          aria-invalid={!!value && !point}
        />
      </label>
      <small>Latitude e longitude: decimal, 22°58′12″S 44°26′40″W ou 225812S 0442640W.</small>
      {value && !point ? (
        <small role="status">
          Confira as duas coordenadas e os hemisférios. Minutos e segundos devem ser menores que 60.
        </small>
      ) : null}
      {point ? (
        <div className="coordinateMap">
          <iframe
            title={`Localização de ${label} no Google Maps`}
            src={`https://www.google.com/maps?q=${encodeURIComponent(query)}&z=13&output=embed`}
            loading="lazy"
            referrerPolicy="no-referrer"
          />
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Abrir no Google Maps ↗
          </a>
        </div>
      ) : null}
    </div>
  );
}

export function LegDistance({
  origin,
  destination,
}: {
  origin?: Coordinates | null;
  destination?: Coordinates | null;
}) {
  const distance = origin && destination ? straightLineDistance(origin, destination) : null;
  const format = (n: number) =>
    n.toLocaleString('pt-BR', { maximumFractionDigits: 1, minimumFractionDigits: 1 });
  return (
    <div className="legDistance" role="status">
      {distance ? (
        <>
          <strong>
            Distância em linha reta: {format(distance.km)} km · {format(distance.nm)} milhas
            náuticas
          </strong>
          <small>Estimativa entre as coordenadas; não inclui desvios da rota.</small>
        </>
      ) : (
        <small>
          A distância aparecerá quando origem e destino tiverem coordenadas disponíveis.
        </small>
      )}
    </div>
  );
}
